import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import InvCostBreakupRow from './InvCostBreakupRow'
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle';
import FormButton from '../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../library/layout/Index";

//TODO check if Total Amount is read correctly

const InvCostBreakup = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '700px'}}
            contentStyle={{ height: '380px' }}
            formTitle={<FormTitle formObject={formObject} value='Cost Breakup' />}
            formObject={formObject} >
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value="Total Amount" /></span>
                        <FormROValue format="#" formObject={formObject} rowKey="totalAmt" action={{ paramName: "totalAmt" }} className='uiVal' />
                    </UiTitle>
                    <UiAction>
                        <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                            action={{ actionId: "new",  actionParam: {}, containerKey: "row" }}
                            text={<SarasTrans value="Add Record" />}>
                        </FormButton>
                    </UiAction>
                </UiViewHeading>
                <div>
                    <FormROValue formObject={formObject} rowKey="" headerKey="brkUpDtls"  action={{ paramName: "itemName" }} className='uiVal' />
                </div>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter " style={{width:"185px"}}><SarasTrans value="Purpose" /></li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Cost" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Is Charged" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Is Inv Payee" /></li>
                                <li className="uiColumnCenter " style={{width:"185px"}}><SarasTrans value="Comment" /></li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Action" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData).map((row, index) => (
                                row.rowKey !== "totalAmt" ? (<li><InvCostBreakupRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} /></li>) : ""
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(InvCostBreakup, "costbreakup", "itemDetail,invTrnFooter")